import { jsx as o } from "react/jsx-runtime";
const l = (c) => /* @__PURE__ */ o(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ...c,
    children: /* @__PURE__ */ o(
      "path",
      {
        fill: "currentcolor",
        d: "M22.075 12.249c0-5.523-4.477-10-10-10s-10 4.477-10 10c0 4.69 3.229 8.624 7.584 9.705v-6.65H7.597v-3.056H9.66v-1.316c0-3.404 1.54-4.981 4.882-4.981.634 0 1.727.124 2.174.248v2.77a13 13 0 0 0-1.155-.037c-1.64 0-2.273.62-2.273 2.236v1.08h3.266l-.561 3.056h-2.705v6.871c4.951-.598 8.788-4.814 8.788-9.926"
      }
    )
  }
);
export {
  l as default
};
